import { render } from "./Kontak.vue?vue&type=template&id=38681bac&scoped=true"
import script from "./Kontak.vue?vue&type=script&lang=js"
export * from "./Kontak.vue?vue&type=script&lang=js"

import "./Kontak.vue?vue&type=style&index=0&id=38681bac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38681bac"]])

export default __exports__